import * as React from 'react';

import {Card} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    color: theme.palette.text.link,
    flex:1,
    '& .MuiCardHeader-root': {
        borderBottom:'none',
        '& .MuiCardHeader-title': {
            fontSize: '14px',
            fontWeight: 'bold',
            color:'#464646'
        },
        '& .MuiCardHeader-action': {
            marginRight: 0,
            '& .MuiButton-root': {
                color: '#555555',
                borderColor: '#ccc',
                fontSize: '12px',
                borderRadius: '8px',
                padding: '4px 4px',
                textTransform: 'capitalize'
            }
        }
    },
    '& .MuiCardContent-root': {
        padding: '0 16px 16px!important',
        fontSize: '12px',
        '& .count': {
            fontSize: '28px',
            fontWeight: 'bold',
            lineHeight: '35px',
        },
        '& .MuiAvatar-root': {
            width: '35px',
            borderRadius: '4px',
            height: '35px',
            color: 'white',
            fontSize: '12px'
        },
    }
}));


export const ChartsCard = ({children, props, styles}) => {

    return (
        <StyledCard {...props} {...styles}>
            {children}
        </StyledCard>
    )
}